import React from "react";
import moment from "moment";
import { formatEnumForDisplay, getMarkupFromMetadata, getStatusPillStyle, getPriorityPillStyle, getSourceTypePillStyle } from "./constants";

const PILL_BASE = {
  display: "inline-flex",
  alignItems: "center",
  padding: "4px 10px",
  borderRadius: 9999,
  fontSize: 12,
  fontWeight: 500,
};

const DEFAULT_IMAGE =
  "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b";

export default function ProjectCardIssues({ list, onIssueClick }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
      {list.map((issue) => {
        const markup = getMarkupFromMetadata(issue.metadata);
        return (
          <div
            key={issue.id}
            role="button"
            tabIndex={0}
            onClick={() => onIssueClick(issue.id)}
            onKeyDown={(e) => e.key === "Enter" && onIssueClick(issue.id)}
            style={{
              backgroundColor: "#fff",
              padding: "12px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: 12,
              borderBottom: "1px solid #D7D8D9",
              cursor: "pointer",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0, flex: 1 }}>
                <div style={{ width: 64, height: 64, borderRadius: 8, overflow: "hidden", backgroundColor: "#f3f4f6", flexShrink: 0, position: "relative" }}>
                  <img
                    src={issue.image_url || DEFAULT_IMAGE}
                    alt=""
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                  {markup != null && (
                    <span
                      style={{
                        position: "absolute",
                        bottom: 4,
                        right: 4,
                        minWidth: 20,
                        height: 20,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "50%",
                        backgroundColor: "#2563eb",
                        color: "#fff",
                        fontSize: 11,
                        fontWeight: 500,
                        padding: "0 4px",
                      }}
                    >
                      {markup}
                    </span>
                  )}
                </div>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <p style={{ fontWeight: 500, color: "#0d0d0e", fontSize: 14, margin: 0, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                    {issue.description || "-"}
                  </p>
                  <p style={{ fontSize: 12, color: "#949DAA", margin: "4px 0 0 0" }}>
                    {issue.issue_category
                      ? `${issue.issue_category.activityType || ""} • ${issue.issue_category.category || ""}`
                      : "-"}
                  </p>
                </div>
              </div>
              <span style={{ ...PILL_BASE, ...getStatusPillStyle(issue.status), flexShrink: 0 }}>
                {formatEnumForDisplay(issue.status) || "-"}
              </span>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 }}>
              <span style={{ ...PILL_BASE, ...getSourceTypePillStyle() }}>
                {formatEnumForDisplay(issue.source_type) || "-"}
              </span>
              <span style={{ ...PILL_BASE, ...getPriorityPillStyle(issue.issue_category?.severity), flexShrink: 0 }}>
                {formatEnumForDisplay(issue.issue_category?.severity) ?? (issue.issue_category?.severity ?? "-")}
              </span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 8 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <label style={{ fontSize: 12, color: "#949DAA" }}>Issue Created</label>
                <span style={{ fontSize: 14, color: "#0d0d0e" }}>
                  {issue.created_at ? moment(issue.created_at).format("MMM DD, YYYY") : "-"}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
